var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.60538C11.6749 4.86787 11.3487 5.12871 11.0256 5.39308C9.88314 6.32802 8.74166 7.26391 7.5997 8.19979C7.22515 8.50673 6.8513 8.81461 6.47628 9.12085C6.4446 9.14672 6.41339 9.19847 6.36997 9.17754C6.32655 9.15637 6.34885 9.09968 6.34885 9.05899C6.34768 8.21813 6.34791 7.37727 6.34791 6.53618C6.34791 6.36636 6.34439 6.36001 6.17964 6.37506C4.99685 6.48279 3.91286 6.86476 2.94269 7.55674C2.07742 8.17391 1.38981 8.9515 0.931004 9.91138C0.604563 10.5949 0.329282 11.3029 0.0312374 12H0.00776931C0.0054225 11.9492 0.000728883 11.8986 0.000728883 11.8478C0.000259521 11.0578 0.00166761 10.2675 2.48405e-05 9.47742C-0.000913883 9.12062 0.0246663 8.76593 0.0915504 8.41618C0.557392 5.98251 1.93966 4.28385 4.20081 3.30046C4.83915 3.02292 5.51456 2.87991 6.20757 2.82723C6.32867 2.81805 6.35073 2.7696 6.35026 2.65976C6.34627 1.8149 6.34768 0.970045 6.34885 0.125188C6.34885 0.084262 6.32773 0.0280479 6.36997 0.00593864C6.41432 -0.0175819 6.44507 0.0346337 6.47652 0.0602711C7.98997 1.29463 9.50249 2.52993 11.0157 3.76428C11.3424 4.03077 11.6719 4.29397 12.0002 4.55857V4.60561L12 4.60538Z",
    fill: "#F47226"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.216a4ecd3a46cc5c0e7c84d3e85c3779.svg";
export { ForwardRef as ReactComponent };